import { render } from "./ProblemBlank.vue?vue&type=template&id=0702014b&scoped=true"
import script from "./ProblemBlank.vue?vue&type=script&lang=js"
export * from "./ProblemBlank.vue?vue&type=script&lang=js"

import "./ProblemBlank.vue?vue&type=style&index=0&id=0702014b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0702014b"]])

export default __exports__